import React, {useState} from "react";
import AccordionDetails from "@mui/material/AccordionDetails";
import MatchDetail from "../MatchDetail/MatchDetail";
import { useTheme } from "../../../contexts/theme";

interface Match {
    title: string;
    matchDate: string;
    sharedWith: string[];
   // score: string;
   // half: string;
    jobMatch: JobMatch[];
    [key: string]: any;
}

interface JobMatch {
    id: string,
    name: string,
    description: string,
    extraction_schedule: string,
    status: string,
    source: string,
    target: string,
    tag: string[],
    settings: boolean,
    away_team: string,
    home_team: string,
    key_moment_type: string,
    score: string,
    half: string,
    last_event_time: string,
    last_run: string,
    numberClips: number,
    redCard: number,

}

interface MatchInformationsProps {
    match: Match[];
    idEventForNewJob: (id: string)=> void;
    handleFormUpdateMatch : (id: string) => void;
    setMatchData: (updatedMatch: any) => void;
    deleteMatch: (id: string) => void;
    updateMatch: (id: string) => void;
    handleManageJob: (id: string, operation: string) => void;
    handleGetIdForNewJob: (idJob: string, idEvent: string) => void;
    deletingJobById: (idJob: string) => void;
}


const MatchInformations = ({ match, setMatchData, deleteMatch, updateMatch, idEventForNewJob, handleFormUpdateMatch, handleManageJob, handleGetIdForNewJob, deletingJobById }: MatchInformationsProps) => {
    const theme = useTheme();

    return (
        <AccordionDetails style={{ padding: theme.spacing.none }}>
            {match && match.map((matchData, index: number) => (
                <MatchDetail key={index} handleManageJob={handleManageJob} idEventForNewJob={idEventForNewJob} matchData={matchData} setMatchData={(updatedMatch) => {
                    const updatedMatches = [...match];
                    updatedMatches[index] = updatedMatch;
                    setMatchData(updatedMatches);
                }} deleteMatch={deleteMatch} handleFormUpdateMatch={handleFormUpdateMatch} handleGetIdForNewJob={handleGetIdForNewJob} deletingJobById={deletingJobById}
                />
            ))}
        </AccordionDetails>
    );
}

export default MatchInformations;
